// Shared between OnboardingWizard (post-login) and MobileOnboardingView (pre-login Capacitor).
// Hardcoded v1 whitelist per the onboarding design doc; RTDB-served config is v1.1 work.
export const GEO_MISMATCH_RULES = Object.freeze([
  { geo: "MX", suggested: "es-mx", triggers: ["en-us", "en-gb"] },
  { geo: "ES", suggested: "es-es", triggers: ["en-us", "en-gb"] },
  { geo: "BR", suggested: "pt-br", triggers: ["en-us", "en-gb"] },
  { geo: "PT", suggested: "pt-pt", triggers: ["en-us", "en-gb"] },
  { geo: "DE", suggested: "de", triggers: ["en-us", "en-gb"] },
  { geo: "FR", suggested: "fr-fr", triggers: ["en-us", "en-gb"] },
  { geo: "JP", suggested: "ja", triggers: ["en-us", "en-gb"] },
  { geo: "KR", suggested: "ko", triggers: ["en-us", "en-gb"] },
  { geo: "RU", suggested: "ru", triggers: ["en-us", "en-gb"] },
  { geo: "CN", suggested: "zh-cn", triggers: ["en-us", "en-gb"] },
  { geo: "HK", suggested: "zh-hk", triggers: ["en-us", "en-gb"] },
  { geo: "TW", suggested: "zh-hk", triggers: ["en-us", "en-gb"] },
  { geo: "IT", suggested: "it", triggers: ["en-us", "en-gb"] },
  { geo: "VN", suggested: "vi", triggers: ["en-us", "en-gb"] },
  { geo: "TR", suggested: "tr", triggers: ["en-us", "en-gb"] },
  { geo: "NL", suggested: "nl", triggers: ["en-us", "en-gb"] },
  { geo: "PL", suggested: "pl", triggers: ["en-us", "en-gb"] },
  { geo: "ID", suggested: "id", triggers: ["en-us", "en-gb"] },
  { geo: "UA", suggested: "uk", triggers: ["en-us", "en-gb"] },
  { geo: "GR", suggested: "el", triggers: ["en-us", "en-gb"] },
  { geo: "SE", suggested: "sv", triggers: ["en-us", "en-gb"] },
  { geo: "NO", suggested: "no", triggers: ["en-us", "en-gb"] },
  { geo: "DK", suggested: "da", triggers: ["en-us", "en-gb"] },
  { geo: "FI", suggested: "fi", triggers: ["en-us", "en-gb"] },
  // India has five app languages (hi/ta-in/bn-in/te/mr); the rules map one
  // suggestion per geo, so we nudge toward Hindi as the largest speaker base.
  { geo: "IN", suggested: "hi", triggers: ["en-us", "en-gb"] },
]);

// Per BCP 47, the region subtag is the first 2-letter ALPHA segment after the language.
// Locales with variants (e.g. "de-CH-1996") put non-region segments after the region, so
// taking the last part is wrong. Bail at any singleton (-u-, -x-) since extension/private
// blocks follow the region — a 2-letter segment past a singleton is an extension key like
// "co" in "de-u-co-phonebk", not Colombia.
export function navigatorCountryFallback() {
  const locale =
    typeof navigator !== "undefined" ? (navigator.language || "").trim() : "";
  if (!locale) return { country: null, source: "unknown" };
  const parts = locale.split("-");
  for (let i = 1; i < parts.length; i++) {
    if (parts[i].length === 1) break;
    if (/^[a-zA-Z]{2}$/.test(parts[i])) {
      return { country: parts[i].toUpperCase(), source: "browser_fallback" };
    }
  }
  return { country: null, source: "unknown" };
}

export function geoLikelyCodeFor(geoCountry) {
  if (!geoCountry) return null;
  const rule = GEO_MISMATCH_RULES.find((r) => r.geo === geoCountry);
  return rule ? rule.suggested : null;
}

export function pickedTriggersMismatch(geoCountry, pickedCode) {
  if (!geoCountry) return null;
  const rule = GEO_MISMATCH_RULES.find((r) => r.geo === geoCountry);
  if (!rule) return null;
  if (rule.suggested === pickedCode) return null;
  if (!rule.triggers.includes(pickedCode)) return null;
  return rule.suggested;
}
